module.exports = __webpack_public_path__ + "img/monster.1e83441.png";